import DOMPurify from 'dompurify'
import { parse, parseInline } from 'marked'

/**
 * Converting empty HTML tags to empty strings.
 * This is useful for rich text editors that may return empty tags like <p></p>
 * when the content is actually empty.
 */
export const normalizeHtmlValue = (value: string): string => {
    return value.replace(/<\/?[^>]+(>|$)/g, '').trim() === '' ? '' : value
}

// Based on how Candidate Website renders Markdown
export const parseAndSanitizeMarkdown = (content: string, inline?: boolean) => {
    const markdownParsed = inline ? (parseInline(content) as string) : parse(content)
    return DOMPurify.sanitize(markdownParsed, { ADD_ATTR: ['target', 'template-var'] })
}

export const markdownToPlainText = (value: string): string => {
    const html = parseAndSanitizeMarkdown(value)
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return (doc.body.textContent || '').trim()
}
